<div class="layout-sidebar">
    <div class="sidebar-logo-container" style="display: flex;
    justify-content: center;
    align-items: center;
    ">
        <!-- <a class="app-logo" [routerLink]="userService.userRole === 'STAFF' ? '/dashboard/overview' : '/dashboard'">
            <img src="assets/layout/images/WowInventory.svg" alt="Logo"
                class="logo" 
                  style="margin: 0 16px; width: 90px; height: 35px;" />
            <span class="app-name" style="font-size: 2rem; font-weight: 700; color: #5978f7; letter-spacing: 1px;">
                WowInventory
            </span>
        </a> -->

        <a class="app-logo"
         style="margin-bottom: 0.8rem;"
         [routerLink]="userService.userRole === 'STAFF' ? '/dashboard/overview' : '/dashboard'">
            <span
                class="app-name"
                style="
                    font-size: 0.85rem;
                    font-weight: 200;
                    color: #ffffff;
                    letter-spacing: 0.8px;
                    margin: 0;
                    white-space: nowrap;
                    max-width: 120px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: block;
                    text-align: center;
                "
            >
                WowInventory
            </span>
        </a>
    </div>
    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
    <div class="sidebar-help-button">
        <a href="https://help.childcarewow.com/portal/en/kb/wowinventory" target="_blank" rel="noopener noreferrer"
            class="help-link"
            title="Help">
            <i class="pi pi-question-circle"></i>
            <span class="help-label">Help</span>
        </a>
    </div>
</div>